import { VStack, Text } from "@chakra-ui/react";
import { KYDNumericOperator } from "common/interfaces/KYDCampaign";
import React from "react";

export const NumericValueDisplay = ({
  title,
  value,
  operator,
}: {
  title: string;
  value: string;
  operator?: KYDNumericOperator;
}) => {
  return (
    <VStack align="flex-start">
      <Text color="#718096" fontSize="14px" fontWeight={500}>
        {title}
      </Text>
      <Text color="#1A202C" fontSize="20px">
        {operator} {value}
      </Text>
    </VStack>
  );
};
